import type { IconSvgObject } from './types';

const PrismIcon: IconSvgObject = [
  ["path", { d: "M12 15L11.9999 11.5M12 15L4.58967 21.4839M12 15L19.4101 21.4839M19.9999 9V21.5C19.9999 21.7761 19.776 22 19.4999 22H4.49988C4.22374 22 3.99988 21.7761 3.99988 21.5V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.9999 6.5L12 2.79295M3.99988 9H19.9999L12 2L3.99988 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PrismIcon;
